import SharedAsset from '@zenbusiness/common-components/SharedAsset';
import { Link } from 'react-router-dom';

import { useTrackLinkPressed } from '#client/utils/reporting';

/**
 * Logo
 *
 * TODO: Make this a shared component with the AppHeaderLogo.
 *
 * @returns {import('react').ReactNode}
 */
function Logo() {
  const logoPath = '/d/dashboard';

  const handleOnClick = useTrackLinkPressed({
    linkText: 'Return to dashboard',
    destination: logoPath
  }, () => {
    // Allow nav to shrink on mouseOut.
    document.activeElement.blur();
  });

  return (
    <Link
      aria-label="Return to dashboard"
      onClick={handleOnClick}
      tabIndex={0}
      to={logoPath}
    >
      <SharedAsset
        alt="ZenBusiness Inc."
        src="/s2/vector/zb-bug-color-2022-wb.svg"
        width={44}
      />
    </Link>
  );
}

export default Logo;
